import React, { memo, useMemo, lazy, Suspense } from 'react'
import { Loading } from 'components/shared'
import { useSelector } from 'react-redux'

import { 
	LAYOUT_TYPE_CLASSIC, 
	LAYOUT_TYPE_MODERN, 
	 
} from 'constants/theme.constant'

import useAuth from 'utils/hooks/useAuth'

const layouts = {
	// [LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
	[LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
	// [LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
	// [LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
	// [LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
	// [LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
}

const Layout = () => {

	const layoutType = useSelector((state) => state.theme?.layout?.type)

	const { authenticated } = useAuth()

	const AppLayout = useMemo(() => {

		// If user is authenticated → show selected layout
		if (authenticated) {
			return layouts[layoutType] || layouts[LAYOUT_TYPE_CLASSIC]
		}

		// If not authenticated → show auth layout
		return lazy(() => import('./AuthLayout'))

	}, [layoutType, authenticated])

	return (
		<Suspense
			fallback={
				<div className="flex flex-auto flex-col h-[100vh]">
					<Loading loading={true} />
				</div>
			}
		>
			<AppLayout />
		</Suspense>
	)
}

export default memo(Layout)